import { ProductEditor } from '@/components/ProductEditor/ProductEditor';

/** Edit product route — redirects to create when `?id=` is missing. */
export function EditProduct() {
  return <ProductEditor variant="edit" />;
}
